export default function UserXIcon({ width = 16, height = 16, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fill='currentColor'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2 3a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 9a5 5 0 0 1 7.508-4.327 2 2 0 0 0 .08 2.748l.707.706-.71.709A2 2 0 0 0 7.016 13H.5a.5.5 0 0 1-.5-.5zm13.78-3.53a.75.75 0 0 1 0 1.06l-1.594 1.594 1.594 1.59a.75.75 0 0 1-1.06 1.062l-1.594-1.591L9.53 13.78a.75.75 0 0 1-1.06-1.06l1.594-1.594-1.594-1.59a.75.75 0 0 1 1.06-1.062l1.594 1.591L12.72 8.47a.75.75 0 0 1 1.06 0'
      />
    </svg>
  );
}
